export const UTM_CAMPAIGN_QUERY_PARAM = '?utm_campaign=in-app';
